<svg
  version="1.1"
  id="Capa_1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  x="0px"
  y="0px"
  viewBox="0 0 550.801 550.801"
  style="enable-background: new 0 0 550.801 550.801"
  xml:space="preserve"
>
  <g>
    <path
      d="M176.571,283.163c-2.869-9.566-5.74-21.537-8.145-31.105h-0.479c-2.386,9.568-4.778,21.771-7.415,31.105l-9.563,34.225
		h35.651L176.571,283.163z"
    />
    <path
      d="M488.426,197.019H475.2v-63.816c0-0.398-0.063-0.799-0.116-1.202c-0.021-2.534-0.827-5.023-2.562-6.995L366.325,3.694
		c-0.032-0.031-0.063-0.042-0.085-0.076c-0.633-0.707-1.371-1.295-2.151-1.804c-0.231-0.155-0.464-0.285-0.706-0.419
		c-0.676-0.369-1.393-0.675-2.131-0.896c-0.2-0.056-0.38-0.138-0.58-0.19C359.87,0.119,359.037,0,358.193,0H97.2
		c-11.918,0-21.6,9.693-21.6,21.601v175.413H62.377c-17.049,0-30.873,13.818-30.873,30.873v160.545
		c0,17.043,13.824,30.87,30.873,30.87h13.224V529.2c0,11.907,9.682,21.601,21.6,21.601h356.4c11.907,0,21.6-9.693,21.6-21.601
		V419.302h13.226c17.044,0,30.871-13.827,30.871-30.87v-160.54C519.297,210.838,505.47,197.019,488.426,197.019z M96.407,386.068
		l49.286-161.288h47.856l50.019,161.288h-39.242l-12.451-41.401h-46.188l-11.48,41.401H96.407z M237.358,224.78h39.964l19.62,68.202
		c5.511,19.143,10.531,37.567,14.359,57.67h0.728c4.066-19.385,9.092-38.527,14.598-56.953l20.576-68.919h38.76l-54.311,161.288
		h-42.604L237.358,224.78z M453.601,523.353H97.2V419.302h356.4V523.353z M403.202,386.068V224.78h36.619v161.288H403.202z
		 M453.601,197.019H97.2V21.605h250.193v110.513c0,5.967,4.841,10.8,10.8,10.8h95.407V197.019z"
    />
  </g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
</svg>
